module.exports = __webpack_public_path__ + "static/img/home_commission.ae3dfd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_commission.png
// module id = Webj
// module chunks = 0